import { mapAtom } from '../../atoms/map/map'
import { findLayer } from '../utils/findLayer'

export const clearGeofenceFeatures = () => {
  const map = mapAtom.map
  const layer = findLayer(map, 'geofence')

  layer.getSource()?.clear()
}
